// Community installs have no Enterprise account API. Keep the shared dashboard
// import resolvable without issuing requests to unavailable billing endpoints.
const unavailable = () =>
  Promise.reject(new Error('Enterprise account features are unavailable'));

export default {
  toggleDeletion: unavailable,
  checkout: unavailable,
  subscription: unavailable,
  getLimits: unavailable,
  createTopupCheckout: unavailable,
};
